<template>
  <div id="product-list">

    <div id="filter-toggle" class="expander" v-show="mobileMode" v-bind:class="{expanded: filters_expanded}">
      <h3 @click="toggleExpander">{{ t('flt_filters') }}</h3>
      <div class="icon-expander"></div>
    </div>
    <div id="filters">

      <div id="filter-gender" class='selectioner'>
        <div class='label'>{{ t('flt_kind') }}
          <div class="arrow"></div>
        </div>
        <ul class='options-panel'>
          <li v-on:click.stop="addFilter('genders','flt_female')"
              v-bind:class="{active: filters.genders.indexOf('flt_female') !== -1}">{{ t('flt_female') }}
          </li>
          <li v-on:click.stop="addFilter('genders','flt_male')"
              v-bind:class="{active: filters.genders.indexOf('flt_male') !== -1}">{{ t('flt_male') }}
          </li>
          <li v-on:click.stop="addFilter('genders','flt_kids')"
              v-bind:class="{active: filters.genders.indexOf('flt_kids') !== -1}">{{ t('flt_kids') }}
          </li>
        </ul>
      </div><!-- filter-gender -->

      <div id="filter-wheel-size" class='selectioner'>
        <div class='label'>{{ t('flt_wheel_size') }}
          <div class="arrow"></div>
        </div>
        <ul class='options-panel'>
          <li :key="ws_index" v-for="(ws,ws_index) in wheelSizes" v-bind:data-value="ws"
              v-on:click.stop="addFilter('sizes',ws)"
              v-bind:class="{active: filters.sizes.indexOf(ws) !== -1}">
            <div class='box'>{{ws}}</div>
          </li>
        </ul>
      </div><!-- filter-wheel-size -->

      <div id="filter-gears" class='selectioner'>
        <div class='label'>{{ t('flt_gears_count') }}
          <div class="arrow"></div>
        </div>
        <ul class='options-panel'>
          <li :key="gear_index" v-for="(gear,gear_index) in gears" v-bind:data-value="gear"
              v-on:click.stop="addFilter('gears',gear)"
              v-bind:class="{active: filters.gears.indexOf(gear) !== -1}">
            <div class='box'>{{gear}}</div>
          </li>
        </ul>
      </div><!-- filter-gears -->

      <div id="filter-color" class='selectioner'>
        <div class='label'>{{ t('flt_color') }}
          <div class="arrow"></div>
        </div>
        <ul class='options-panel'>
          <li :key="color_index" v-for="(color,color_index) in colors" v-bind:data-value="color.color_name"
              v-on:click.stop="addFilter('colors',color_index)"
              v-bind:class="{active: filters.colors.indexOf(color_index) !== -1}">
            <div class='color icon' v-bind:style='color.icon'></div>
          </li>
        </ul>
      </div><!-- filter-color -->

    </div><!-- filters -->

    <div class="selected_filters">
      <ul>
        <li :key="gender_filter" v-for="gender_filter in filters.genders"
            v-on:click='removeFilter("genders",gender_filter)'>{{ t(gender_filter) }}
        </li>
        <li :key="sizes_filter" v-for="sizes_filter in filters.sizes"
            v-on:click='removeFilter("sizes",sizes_filter)'>{{ sizes_filter }}
        </li>
        <li :key="gears_filter" v-for="gears_filter in filters.gears"
            v-on:click='removeFilter("gears",gears_filter)'>{{ t('flt_gears') + ': ' + gears_filter}}
        </li>
        <li :key="color_filter" v-for="color_filter in filters.colors"
            v-on:click='removeFilter("colors",color_filter)'>{{ colors[color_filter].color_name }}
        </li>
      </ul>
    </div>
    <div class="found_items">
      <p>{{ t('found_items_count') }}&nbsp;<span>{{matchedItems}}</span></p>
    </div>
    <div class="product-list">

      <div v-bind:key="serie_index" v-for="(serie,serie_index) in products" class='seria'
           v-bind:class="{matched: serieHasActiveItems(serie_index)}">
        <serie-logo :serie="serie_index.toLowerCase()"></serie-logo>
        <div class="serie-desc">{{getSerieLead(serie_index.toLowerCase())}}</div>
        <ul class='products'>
          <li v-bind:key="product_index" v-for="(product,product_index) in serie"
              v-bind:class="{
                          'matched': product.matched,
                          'bike' : true,
                          'kind-f': product.gender === 'F',
                          'kind-m': product.gender === 'M',
                          'kind-k': product.gender === 'K',
                          'kind-u': product.gender === 'U'
                        }"
          >
            <item :product="product"/>
          </li>
        </ul><!-- product -->
      </div><!-- list wrap -->

      <div id='not-found' v-if="matchedItems == 0">
        <h1>{{ t('nothing_found') }}</h1>
      </div>
    </div><!-- product list -->

  </div>
</template>

<script>
  import jQuery from 'jquery'
  import SerieLogo from './../Graphics/SerieLogo'
  import Item from './Item'
  import $ from 'jquery'

  export default {
    name: 'bikes-list',
    components: {
      SerieLogo,
      Item
    },

    created: function () {

      let prods = window.env.data.bikes;
      this.products = _.orderBy(prods,[
          function (b) { return parseInt(b.position);},
          function (a) { return parseInt(a.sort_order);}
        ],
        ['asc','desc']);


      this.gatherColors();
      this.gatherSizes();
      this.gatherGears();
      //this.gatherGroups();
      this.matchedItems = this.products.length
      this.products = _.groupBy(this.products, function (product) {
        return product.group_name;
      });

      this.applyFilters();
      this.filters_expanded = !this.mobileMode;
    },
  
    mounted: function () {
      jQuery('.selectioner').on('click', function () {
        jQuery(this).toggleClass('active')
      }).on('mouseleave', function (e) {
        e.stopPropagation();
        jQuery(this).removeClass('active')
      })

    },

    data() {
      return {
        filters: {
          genders: [],
          sizes: [],
          gears: [],
          colors: []
        },
        mobileMode: ($(window).width() < env.mobileTreshold),
        filters_expanded: true,
        matchedItems: 0,
        searchText: '', // nie wyszukujemy nic
        series: [], // tu zbierzemy wszystkie serie roweów
        wheelSizes: [],
        colors: {}, // a tu unikalne kolory
        gears: [],
        products: []
      }
    }, // data

    methods: {
      /**
       * W wersji mobilnej ukrywamy i rozwijamy listę filtrów
       */
      toggleExpander(e) {
        let panel = $(e.target).parent().next();
        if (this.filters_expanded) {
          panel.slideUp();
          this.filters_expanded = false
        } else {
          panel.slideDown();
          this.filters_expanded = true
        }
      },
      /**
       * Dodawanie filtra do listy
       */
      addFilter: function (kind, filter) {
        if (this.filters[kind].indexOf(filter) === -1) {
          this.filters[kind].push(filter)
        } else {
          this.removeFilter(kind, filter)
        }
        this.applyFilters()
      },

      getSerieLead(serie_name)
      {
        return window.translations['sr_' + serie_name + '_hd'];
      },

      /**
       * Usuwanie filtra z listy
       */
      removeFilter: function (kind, filter) {
        var index = this.filters[kind].indexOf(filter)
        if (index !== -1) {
          this.filters[kind].splice(index, 1)
        }
        this.applyFilters()
      },

      /**
       * Tłumaczenie stringów z tablicy przekazanej z serwera
       */
      t: function (txt) {
        if (_.has(translations, txt)) {
          return translations[txt]
        }
        console.log('t nie znalazł tłumaczeń dla', txt, translations)
        return txt
      }, // t

      /**
       * Pobieranie serii rowerów
       */
      // gatherGroups: function () {
      //   let series = [];
      //   let prods = _.map(_.sortBy(_.groupBy(this.products,'group_name'),function(a){ return parseInt(a.position) }),'group_name');
      //
      //
      //   // console.log(prods);
      //   // _.forEach(prods, element => {
      //   //   if (series.indexOf(element.group_name) === -1) {
      //   //     series.push(element.group_name)
      //   //   }
      //   // })
      //   this.series = prods;
      // }, // gatherGroups

      /**
       * Pobieranie ilości biegów
       */
      gatherGears: function () {
        _.forEach(this.products, element => {
          if (this.gears.indexOf(element.gears) === -1) {
            this.gears.push(element.gears)
            this.gears = _.orderBy(this.gears, Number, ['asc'])
          }
        })
      }, // gatherGears

      /**
       * Pobieranie ilości biegów
       */
      gatherSizes: function () {
        _.forEach(this.products, product => {
          _.forEach(product.sizes, (size, sizeIndex) => {
            if (this.wheelSizes.indexOf(sizeIndex) === -1) {
              this.wheelSizes.push(sizeIndex)
              this.wheelSizes = _.orderBy(this.wheelSizes, String, ['asc'])
            }
          })
        })
      }, // gatherGears

      /**
       * Ustanawia ścieżkę do pliku ze zdjęciem
       * @param {*} color
       */
      generateVariantPhotoName(color) {
        return env.baseUrl +
          '/photos/styles/list/' +
          env.collection +
          '/bikes/legrand_' +
          color.photo_color +
          (color.is_glossy === '1' ? '_polysk' : '_mat') + '.png'
      }, // generateVariantPhotoName

      /**
       * Pobieranie unikalnych kolorów
       */
      gatherColors: function () {
        let that = this

        _.forEach(this.products, product => {
          _.forEach(product.colors, (color, index) => {
            if (typeof (that.colors[index]) !== 'object') {
              that.colors[index] = {
                color_base: index,
                color_name: color.main_color,
                main_color_hex: color.main_color_hex,
                icon: 'background-color: #' + color.main_color_hex
              }
            }
          })
        })
      }, // gatherColors

      // szukamy pustych serii do ukrycia
      serieHasActiveItems: function (el) {
        var matched = false
        _.forEach(this.products[el], function (item) {
          if (item.matched) {
            matched = true
          }
        })
        return matched
      }, // serieHasActiveItems

      // przestawianie zdjęcia karuzeli na wybrany kolor
      switchCarouselToColor: function (productId, mainColor) {
        console.log('.variants.id-' + productId + ' li.' + mainColor)
        let index = jQuery('.variants.id-' + productId + ' li.' + mainColor).index()
        jQuery('.variants.id-' + productId).jcarousel('scroll', index)
      }, // switchCarouselToColor

      getProductLink: function (product) {
        let link = env.baseUrl + translations['route-bike'] + '/' + product.internal_name
        return link
      },
      /**
       * Obsługa filtrów
       */
      applyFilters: function () {
        this.matchedItems = 0
        _.forEach(this.products, serie => {
          _.forEach(serie, product => {
            let matched = true
            if (this.filters.genders.length > 0) {
              let genders = {M: 'flt_male', F: 'flt_female', K: 'flt_kids'};
              console.log(genders[product.gender]);
              matched = matched && this.filters.genders.indexOf(genders[product.gender]) !== -1
            }

            if (this.filters.gears.length > 0) {
              matched = matched && this.filters.gears.indexOf(product.gears) !== -1
            }

            if (this.filters.sizes.length > 0) {
              var found = false
              for (var i = 0; i < this.filters.sizes.length; i++) {
                if (_.has(product.sizes, this.filters.sizes[i])) {
                  found = true
                }
              }
              matched = matched && found
            }

            if (this.filters.colors.length > 0) {
              let found = false
              for (let i = 0; i < this.filters.colors.length; i++) {
                if (_.has(product.colors, this.filters.colors[i])) {
                  found = true
                }
              }
              matched = matched && found
              if (found) {
                this.setSelectedColor(product, this.filters.colors[0])
              }
            }
            product.matched = matched
            if (matched) this.matchedItems++
          })
        })
      }, // applyFilters
      setSelectedColor: function (product, color) {
        let i = 0
        _.forEach(product.colors, (c, k) => {
          if (k === color) product.col_sel = i
          i++
        })
      }
    } // methods
  }
</script>



// WEBPACK FOOTER //
// src/components/Products/BikesList.vue